export { Is } from './is';
